"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSiteSettingsMergeTags = exports.updateSiteSettings = exports.fetchSiteSettings = void 0;

var _ = require("_");

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var _constants = require("./constants");

var _selectors2 = require("settings-ui-sdk/Auth/selectors");

// attachedStylesheets is stored as an OrderedMap which .toJSes to
// an object, but the backend wants an array
function storeAttachedStylesheetsAsArray(siteSettings) {
  var immutableStylesheets = siteSettings.get(_constants.ATTACHED_STYLESHEETS);

  if (!immutableStylesheets) {
    return siteSettings;
  }

  return siteSettings.set(_constants.ATTACHED_STYLESHEETS, immutableStylesheets.toArray());
}

var fetchSiteSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSiteSettings,
  initiatingActionType: _actions.SiteSettingsActionTypes.LOAD_SITE_SETTINGS,
  requestStatusSelector: _selectors.getFetchSiteSettingsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSiteSettings
}));
exports.fetchSiteSettings = fetchSiteSettings;

var updateSiteSettings = function updateSiteSettings($action, _ref) {
  var getState = _ref.getState;
  return $action.ofType(_actions.SiteSettingsActionTypes.SAVE_SITE_SETTINGS_CHANGES).pipe((0, _mergeMap.mergeMap)(function (action) {
    var data = action.payload.data;
    var canSaveAllSettings = (0, _selectors2.hasContentSettingsScope)(getState());
    var promise;

    if (!canSaveAllSettings) {
      promise = (0, _fromPromise.fromPromise)(_API.default.updateColorPickerFavorites((0, _.pick)(data, [_constants.COLOR_PICKER_FAVORITE_1, _constants.COLOR_PICKER_FAVORITE_2, _constants.COLOR_PICKER_FAVORITE_3, _constants.COLOR_PICKER_FAVORITE_4, _constants.COLOR_PICKER_FAVORITE_5, _constants.COLOR_PICKER_FAVORITE_6])));
    } else if (data.bodyOverrideByDomain) {
      Object.keys(data.bodyOverrideByDomain).forEach(function (domain) {
        var currentOverrides = (0, _selectors.getSiteSettingsByDomain)(getState(), domain);

        if (currentOverrides) {
          currentOverrides = storeAttachedStylesheetsAsArray((0, _selectors.getSiteSettingsByDomain)(getState(), domain));
          var withoutExtraKeys = (0, _.pick)(data.bodyOverrideByDomain[domain], currentOverrides.keySeq().toArray());
          data.bodyOverrideByDomain[domain] = currentOverrides.merge(withoutExtraKeys).toJS();
        }
      });
      promise = (0, _fromPromise.fromPromise)(_API.default.updateSiteSettingsOverrides(data.bodyOverrideByDomain));
    } else {
      promise = (0, _fromPromise.fromPromise)(_API.default.updateSiteSettings(data));
    }

    return promise.pipe((0, _map.map)(function (response) {
      return _actions.SaveSiteSettingsChanges.success(response, data);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.SaveSiteSettingsChanges.failure(error, data));
    }), (0, _startWith.startWith)(_actions.SaveSiteSettingsChanges.request(data)));
  }));
};

exports.updateSiteSettings = updateSiteSettings;

var updateSiteSettingsMergeTags = function updateSiteSettingsMergeTags($action) {
  return $action.ofType(_actions.SiteSettingsActionTypes.SAVE_SITE_SETTINGS_MERGE_TAG_CHANGES).pipe((0, _mergeMap.mergeMap)(function (action) {
    var data = action.payload.data;
    return (0, _fromPromise.fromPromise)(_API.default.updateSiteSettingsMergeTags(data)).pipe((0, _map.map)(function (response) {
      return _actions.SaveSiteSettingsChanges.success(response, data);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.SaveSiteSettingsChanges.failure(error, data));
    }), (0, _startWith.startWith)(_actions.SaveSiteSettingsChanges.request(data)));
  }));
};

exports.updateSiteSettingsMergeTags = updateSiteSettingsMergeTags;